import { render, staticRenderFns } from "./TabExpediente.vue?vue&type=template&id=7d53d348"
import script from "./TabExpediente.vue?vue&type=script&lang=js"
export * from "./TabExpediente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d53d348')) {
      api.createRecord('7d53d348', component.options)
    } else {
      api.reload('7d53d348', component.options)
    }
    module.hot.accept("./TabExpediente.vue?vue&type=template&id=7d53d348", function () {
      api.rerender('7d53d348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/formalizacionactas/TabExpediente.vue"
export default component.exports